/**
 * Prevents open redirects (e.g. ?next=//evil.com) and keeps post-login navigation inside certification.
 */
export function parseSafeCertificationNext(raw) {
  const fallback = '/certification'
  if (raw == null || typeof raw !== 'string') return fallback

  let path
  try {
    path = decodeURIComponent(raw.trim())
  } catch {
    return fallback
  }

  if (!path.startsWith('/')) return fallback
  if (path.startsWith('//')) return fallback
  if (path.includes('://')) return fallback
  if (path.includes('..')) return fallback

  const pathOnly = (path.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/').replace(/\/+/g, '/') || '/'

  if (pathOnly === '/certification/sign-in') return fallback

  const allowedExact = new Set(['/certification', '/certification/my-results'])
  if (allowedExact.has(pathOnly)) return pathOnly

  if (pathOnly === '/certification/global' || pathOnly === '/certification/india') return pathOnly

  return fallback
}
